export default __webpack_public_path__ + "static/media/06__o_preview_3.71e472bc.jpg";